import Loader from "react-loader-spinner";

const MyLoader = () => {
  return <Loader type="TailSpin" color="#ccc" height={25} />;
};

export default MyLoader;
